import {
  RegionType,
  ClientRowType,
  ClientType,
  LookupDataType,
  BrandType,
  RowType,
  ClientAutoCompleteOptionType,
} from "./types"

import { httpExport, httpRevenue } from "api/http"

export const fetchLookUp = async () => {
  return (await httpRevenue.get("lookUp").json()) as LookupDataType
}

export const fetchRegionMarkets = async (_key: string, params: string) => {
  const searchParams = new URLSearchParams(params)
  return (await httpRevenue
    .get(`region/${searchParams.get("region")}/markets`, { searchParams })
    .json()) as { markets: RegionType[] }
}
export const fetchRegions = async (_key: string, params: string) => {
  const searchParams = new URLSearchParams(params)
  searchParams.get("market") === "All" && searchParams.set("market", "")
  return (await httpRevenue
    .get(`regions`, { searchParams })
    .json()) as RegionType[]
}

export const fetchMarket = async (_key: string, params: string) => {
  const searchParams = new URLSearchParams(params)
  return (await httpRevenue
    .get(
      `region/${searchParams.get("region")}/market/${searchParams.get(
        "market",
      )}`,
      { searchParams },
    )
    .json()) as RowType
}

export const fetchTableData = async (
  _key: string,
  url: string,
  searchParams: string,
) => {
  return (await httpRevenue.get(url, { searchParams }).json()) as ClientRowType
}

export const fetchClientView = async (
  _key: string,
  url: string,
  searchParams: string,
) => {
  return (await httpRevenue.get(url, { searchParams }).json()) as ClientType
}

export const fetchBrand = async (_key: string, params: string) => {
  const searchParams = new URLSearchParams(params)
  searchParams.get("market") === "All" && searchParams.set("market", "")
  return (await httpRevenue
    .get(`brand/${searchParams.get("brand")}`, { searchParams })
    .json()) as BrandType
}

export const fetchClients = async (_key: string, params: string) => {
  const searchParams = new URLSearchParams(params)
  searchParams.get("name") === "All" && searchParams.set("name", "")
  return (await httpRevenue
    .get(`clients`, { searchParams })
    .json()) as ClientAutoCompleteOptionType[]
}

// DRILLDOWN /////////////////////////////

export const fetchDetailsGCF = async (_key: string, searchParams: string) => {
  return (await httpRevenue
    .get(`Details/Gcf`, {
      searchParams,
    })
    .json()) as any
}

export const fetchDetailsNonGCF = async (
  _key: string,
  searchParams: string,
) => {
  return (await httpRevenue
    .get(`Details/nonGcf`, { searchParams })
    .json()) as any
}

// EXPORT//////////////////////////////////
export const exportTable = async (
  type: string,
  params: { filters: string },
) => {
  return httpExport
    .get(`${type}/fd${params.filters}`, { timeout: false })
    .blob()
}
